import * as React from 'react';
import { Button } from "@progress/kendo-react-buttons";
import styled from "styled-components";
import Popup from "../components/CusPopup";

const ButtonToggle = styled(Button)`
color: blue;
opacity: 0.7;
background-color: transparent;
background-repeat: no-repeat;
border: none;
margin-top: -0.4em;
margin-left: -0.4em;
&:hover {
    background-color: transparent;
  }
${({ active }) =>
        active &&
        `opacity: 1; `}`;

const CusTwoBtnDialog = (props) => {

    return (
        <div style={{ textAlign: 'center' }}>
            <Popup
                className="popUpBox"
                trigger={props.show}
                setTrigger={props.setShow}>
                <div style={props.style}>
                    <div>{props.label}</div>
                </div>
                <br />

                <div className="row">
                    <div className="col-1"></div>
                    <div className="col-5" style={{ textAlign: "left" }}>
                        <Button
                            look="outline"
                            className="btSize1 sccbTxt2"
                            onClick={props.leftBtnClick} >
                            {props.leftBtnName}
                        </Button>
                    </div>
                    <div className="col-5" style={{ textAlign: "right" }}>
                        <Button
                            look="outline"
                            className="btSize1 sccbTxt2"
                            onClick={props.rightBtnClick}>
                            {props.rightBtnName}
                        </Button>
                    </div>
                    <div className="col-1"></div>
                </div>
            </Popup>
        </div>

    )
}


export default CusTwoBtnDialog;